import CheckBoxImage from './CheckBoxImage'

export default CheckBoxImage